/**
 * Extracts the KeyCloakId (sub claim) from a JWT token.
 * @param token - The JWT token string
 * @returns The KeyCloakId (sub claim) or null if extraction fails
 */
export const getKeyCloakIdFromToken = (token: string): string | null => {
    try {
        const payload = JSON.parse(atob(token.split(".")[1])) as { sub?: string };
        return payload.sub ?? null;
    } catch (error) {
        console.error("[Heap] Failed to extract KeyCloakId from token:", error);
        return null;
    }
};
